<template lang="pug">
div
  template(v-if="customerSelected")
    CustomerFields(:customer="selectedCustomer" disabled)
  template(v-else)
    FindCustomerInput(
      @selected="selectExisting"
      ref="findCustomer"
      @lastSearchQuery="v => $emit('lastSearchQuery', v)"
      data-test-id="find-customer-input"
      )
</template>

<script>
import CustomerFields from './CustomerFields.vue'
import FindCustomerInput from '@/vue/components/FindCustomerInput.vue'

export default {
  name: 'FindCustomer',
  components: { CustomerFields, FindCustomerInput },
  data() {
    return {
      selectedCustomer: null,
    }
  },
  computed: {
    customerSelected() {
      return this.selectedCustomer
    },
  },
  methods: {
    selectExisting(customer) {
      this.selectedCustomer = customer
      this.$emit('selected', customer.Key)
    },
    reset() {
      this.selectedCustomer = null
    },
  },
}
</script>

<style lang="stylus">
.email
  color #798696
</style>
